<script setup lang="ts">
/**
 * 根组件。三件事：恢复侧栏折叠状态、挂全局的 toast / confirm 宿主、
 * **把仍在用的 Element Plus 组件的内置文案钉成中文**。
 *
 * ## 为什么还需要 `ElConfigProvider`
 *
 * 组件库迁到自研 `AppXxx` 之后 `ElMessage` / `ElMessageBox` 已经清零 ——
 * 那两个曾经是这一层最主要的理由。但 EP **没有下架**：`el-pagination`、
 * `el-select`、`el-descriptions`、`el-input-number` 这些还在页面上，
 * 而它们各自带着内置文案（分页器的「共 N 条 / 前往 X 页」、选择器的空态、
 * 日期选择器的月份名）。不配 locale 的话，一个满屏中文的页面上会冒出
 * `Go to` / `No data` 这样的英文碎片。
 *
 * 所以这一层留着，直到 EP 真的从 `package.json` 里消失。
 *
 * ## `ToastHost` / `ConfirmHost` 放在 provider 里面
 *
 * 它们是自研组件、不读 EP 的 locale，放里放外都一样。放里面只是让
 * 「整棵树都在同一个 provider 下」这件事在结构上一眼可见。
 */
import { onMounted } from 'vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

import { ConfirmHost, PromptHost, ToastHost } from '@/components/ui'
import { useAppStore } from '@/stores/app'

const app = useAppStore()

onMounted(() => {
  app.restoreSidebar()
})
</script>

<template>
  <el-config-provider :locale="zhCn">
    <RouterView />
    <ToastHost />
    <ConfirmHost />
    <PromptHost />
  </el-config-provider>
</template>
